<mat-card class="mat-card-margin-bottom">
  <mat-toolbar>
    <mat-toolbar-row class="header-style">
      Options Schedule
      @if (loading) {
        <mat-spinner [diameter]="30"></mat-spinner>
      }
      <button
        mat-mini-fab
        class="button"
        color="default"
        type="button"
        [matMenuTriggerFor]="menu"
        *ngxPermissionsOnly="'editSchedules'"
        matTooltip="Add new schedule">
        <mat-icon color="secondary" aria-label="Add">add</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @if (canPromoteMembershipType) {
          <div class="menu-section-title">FR/BE membership type</div>
          @if (canPromoteToUnlimited) {
            <button mat-menu-item (click)="handlePromoteToUnlimited()">
              <mat-icon>all_inclusive</mat-icon>
              <span>Promote to Unlimited</span>
            </button>
          }
          @if (canPromoteToCredits) {
            <button mat-menu-item (click)="handlePromoteToCredits()">
              <mat-icon>toll</mat-icon>
              <span>Promote to Credits</span>
            </button>
          }
          <div class="menu-section-title">Options</div>
        }
        <button mat-menu-item (click)="handleWellpassOnboarding()">
          Schedule Wellpass Onboarding
        </button>

        <button mat-menu-item (click)="handlePlus1Activation()">
          Schedule Plus1 Activation
        </button>

        <button mat-menu-item (click)="handleWellpassOffboarding()">
          Schedule Wellpass Offboarding
        </button>

        <button mat-menu-item (click)="handlePlus1Deactivation()">
          Schedule Plus1 Deactivation
        </button>

        <button mat-menu-item (click)="handleCustom()">Custom</button>
      </mat-menu>
    </mat-toolbar-row>
  </mat-toolbar>

  <ngx-adm-int-error [error]="error"></ngx-adm-int-error>

  @if (hasMembershipTypeConflict) {
    <gymfinder-alert variant="warning" class="alert-margin-top">
      <span>
        This gym has <strong>both Credits and Unlimited</strong>, which is not a
        valid FR/BE configuration. Use <strong>Promote to Unlimited</strong> or
        <strong>Promote to Credits</strong> from the
        <mat-icon inline>add</mat-icon> menu to fix it.
      </span>
    </gymfinder-alert>
  }

  <gymfinder-alert variant="info" class="alert-margin-top">
    <span>
      <strong>Note:</strong> in case you want to schedule onboarding or
      offboarding, you don't need to change "Wellpass" or "Plus1" training
      option now, it will be done automatically on the date you'd select in the
      table.
      @if (canPromoteMembershipType) {
        <br />
        To switch an FR/BE gym between Credits and Unlimited, use
        @if (canPromoteToUnlimited) {
          <strong>Promote to Unlimited</strong>
        }
        @if (canPromoteToUnlimited && canPromoteToCredits) {
          /
        }
        @if (canPromoteToCredits) {
          <strong>Promote to Credits</strong>
        }
        instead of a Custom schedule, so the other type and the credits
        configuration are handled for you.
      }
    </span>
  </gymfinder-alert>

  <mat-tab-group>
    <mat-tab label="Pending">
      <gymfinder-attribute-change-schedule-table
        [schedules]="pendingSchedules"
        [allowEdit]="true"
        (scheduleDelete)="
          handleScheduleDelete($event)
        "></gymfinder-attribute-change-schedule-table>
    </mat-tab>
    <mat-tab label="Executed">
      <gymfinder-attribute-change-schedule-table
        [allowEdit]="false"
        [schedules]="
          executedSchedules
        "></gymfinder-attribute-change-schedule-table>
    </mat-tab>
  </mat-tab-group>
</mat-card>
